import { render, staticRenderFns } from "./pos-table.vue?vue&type=template&id=10dc5151&"
import script from "./pos-table.vue?vue&type=script&lang=js&"
export * from "./pos-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports